import { render } from "./GalleryBuildingMark.vue?vue&type=template&id=550c0828&scoped=true"
import script from "./GalleryBuildingMark.vue?vue&type=script&lang=js"
export * from "./GalleryBuildingMark.vue?vue&type=script&lang=js"

import "./GalleryBuildingMark.vue?vue&type=style&index=0&id=550c0828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550c0828"]])

export default __exports__